export var RoleEnum = {
    NONE: "None",
    AGENCY_WORKER: "AgencyWorker",
    COLLECTIONS_ADMINISTRATOR: "CollectionsAdministrator",
    DISTRIBUTOR: "Distributor",
    LOGGED_USER: "LoggedUser",
    ONIX_CODETABLES_ADMINISTRATOR: "OnixCodetablesAdministrator",
    PUBLISHER_ADMIN: "PublisherAdmin",
    PUBLISHER_GUARANTOR: "PublisherGuarantor",
    PUBLISHER_SYSTEM: "PublisherSystem",
    SUPERUSER: "Superuser",
    SYSTEM: "System",
    LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS: "LibrarianLegalDepositsMonographs",
    LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS: "LibrarianLegalDepositsPeriodicals",
    ADMIN_LEGAL_DEPOSITS: "AdminLegalDeposits",
    EXPORT_API_CLIENT: "ExportApiClient",
};
